export const symptomDefinitions = [
  {
    propertyName: 'period_flow',
    label: 'period flow',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Spotting' },
      { value: 'Light' },
      { value: 'Medium' },
      { value: 'Heavy' },
    ],
  },
  {
    propertyName: 'breakthrough_bleeding',
    label: 'breakthrough bleeding',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Light' },
      { value: 'Medium' },
      { value: 'Heavy' },
    ],
  },
  {
    propertyName: 'cervical_fluid',
    label: 'cervical fluid',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Egg-White' },
      { value: 'Sticky' },
      { value: 'Creamy' },
      { value: 'Atypical' },
    ],
  },
  {
    propertyName: 'cervical_position',
    label: 'cervical position',
    type: 'select',
    options: [{ value: 'Low' }, { value: 'High' }, { value: "I didn't check" }],
  },
  {
    propertyName: 'hot_flashes',
    label: 'hot flashes',
    type: 'select',
    options: [
      { value: "I didn't have any" },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'temperature',
    label: 'temperature',
    type: 'number',
    min: 95.0,
    max: 105.9,
    step: 0.1,
  },
  {
    propertyName: 'breast_tenderness',
    label: 'breast tenderness',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'nausea',
    label: 'nausea',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'cramps',
    label: 'cramps',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'joint_pain',
    label: 'joint pain',
    type: 'select',
    options: [
      { value: 'No pain' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'back_pain',
    label: 'back pain',
    type: 'select',
    options: [
      { value: 'Not at all' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'headache',
    label: 'headache',
    type: 'select',
    options: [
      { value: 'No' },
      { value: 'Mild Headache' },
      { value: 'Moderate Headache' },
      { value: 'Severe Headache' },
    ],
  },
  {
    propertyName: 'migraine',
    label: 'migraine',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'head_hair',
    label: 'head hair',
    type: 'select',
    options: [
      { value: 'No changes' },
      { value: 'Hair loss' },
      { value: 'Oily' },
      { value: 'Dry' },
      { value: 'Frizzy' },
      { value: 'Smooth' },
      { value: 'Shiny' },
    ],
  },
  {
    propertyName: 'body_hair_growth',
    label: 'body hair growth',
    type: 'select',
    options: [
      { value: 'No change' },
      { value: 'hair loss' },
      { value: 'hair growth' },
      { value: 'increased thickness' },
      { value: 'hair in new places' },
    ],
  },
  {
    propertyName: 'skin_changes',
    label: 'skin changes',
    type: 'select',
    options: [
      { value: 'Glowing' },
      { value: 'Good' },
      { value: 'Smooth' },
      { value: 'Oily' },
      { value: 'Dry' },
      { value: 'Acne' },
      { value: 'Itchy' },
    ],
  },
  {
    propertyName: 'acne',
    label: 'acne',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Breakout' },
      { value: 'Forehead' },
      { value: 'Cheeks' },
      { value: 'Chin' },
      { value: 'Nose' },
      { value: 'Cystic' },
    ],
  },
  {
    propertyName: 'stool',
    label: 'stool',
    type: 'select',
    options: [
      { value: 'Normal' },
      { value: 'Soft' },
      { value: 'Constipated' },
      { value: 'Diarrhea' },
      { value: 'Painful' },
    ],
  },
  {
    propertyName: 'cravings',
    label: 'cravings',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Sweet' },
      { value: 'Carbs' },
      { value: 'Salty' },
      { value: 'Greasy Food' },
      { value: 'Sour' },
      { value: 'Spicy' },
    ],
  },
  {
    propertyName: 'digestion',
    label: 'digestion',
    type: 'select',
    options: [
      { value: 'Normal' },
      { value: 'Indigestion' },
      { value: 'Nauseated' },
      { value: 'Gassy' },
    ],
  },
  {
    propertyName: 'bloating',
    label: 'bloating',
    type: 'select',
    options: [
      { value: 'Not at all' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'painful_urination',
    label: 'painful urination',
    type: 'select',
    options: [
      { value: 'Not at all' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'urination_frequency',
    label: 'urination frequency',
    type: 'select',
    options: [
      { value: 'Less than normal' },
      { value: 'Normal' },
      { value: 'More than normal' },
    ],
  },
  {
    propertyName: 'incontinence',
    label: 'incontinence',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'sexual_activity',
    label: 'sexual activity',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Unprotected' },
      { value: 'Protected' },
      { value: 'Withdrawal' },
    ],
  },
  {
    propertyName: 'painful_sex',
    label: 'painful sex',
    type: 'select',
    options: [
      { value: "I didn't have sex" },
      { value: 'No pain' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'sex_drive',
    label: 'sex drive',
    type: 'select',
    options: [
      { value: 'Lower than normal' },
      { value: 'Normal' },
      { value: 'Higher than normal' },
    ],
  },
  {
    propertyName: 'exercise_intensity',
    label: 'exercise intensity',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Low-Impact' },
      { value: 'Moderate-Impact' },
      { value: 'High-Impact' },
    ],
  },
  {
    propertyName: 'exercise_perceived_effort',
    label: 'exercise perceived effort',
    type: 'select',
    options: [
      { value: 'Easier than normal' },
      { value: 'normal' },
      { value: 'Harder than normal' },
    ],
  },
  {
    propertyName: 'hours_of_sleep',
    label: 'hours of sleep',
    type: 'select',
    options: [
      { value: '0-3 hrs' },
      { value: '3-6 hrs' },
      { value: '6-9 hrs' },
      { value: '9+ hrs' },
    ],
  },
  {
    propertyName: 'sleep_quality',
    label: 'sleep quality',
    type: 'select',
    options: [
      { value: 'Trouble falling asleep' },
      { value: 'trouble staying asleep' },
      { value: 'restless' },
      { value: 'good quality' },
    ],
  },
  {
    propertyName: 'dreams',
    label: 'dreams',
    type: 'select',
    options: [
      { value: 'No Dreams' },
      { value: 'Dark' },
      { value: 'Disturbing' },
      { value: 'stressful' },
      { value: 'vivid' },
      { value: 'soothing' },
      { value: 'happy' },
    ],
  },
  {
    propertyName: 'mood',
    label: 'mood',
    type: 'select',
    options: [
      { value: 'Very negative' },
      { value: 'Negative' },
      { value: 'Average' },
      { value: 'Positive' },
      { value: 'Very positive' },
    ],
  },
  {
    propertyName: 'anxiety',
    label: 'anxiety',
    type: 'select',
    options: [
      { value: 'Not at all' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'motivation',
    label: 'motivation',
    type: 'select',
    options: [
      { value: 'Better than normal' },
      { value: 'Normal' },
      { value: 'Worse than normal' },
    ],
  },
  {
    propertyName: 'productivity',
    label: 'productivity',
    type: 'select',
    options: [
      { value: 'Better than normal' },
      { value: 'Normal' },
      { value: 'Worse than normal' },
    ],
  },
  {
    propertyName: 'focus',
    label: 'focus',
    type: 'select',
    options: [
      { value: 'Better than normal' },
      { value: 'Normal' },
      { value: 'Worse than normal' },
    ],
  },
  {
    propertyName: 'brain_fog',
    label: 'brain fog',
    type: 'select',
    options: [
      { value: 'No braing fog' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'memory_problems',
    label: 'memory problems',
    type: 'select',
    options: [
      { value: 'Not at all' },
      { value: 'Mild' },
      { value: 'Moderate' },
      { value: 'Severe' },
    ],
  },
  {
    propertyName: 'energy',
    label: 'energy',
    type: 'select',
    options: [
      { value: 'Exhausted' },
      { value: 'Low energy' },
      { value: 'High energy' },
    ],
  },
  {
    propertyName: 'mood_stability',
    label: 'mood stability',
    type: 'select',
    options: [
      { value: 'Stable' },
      { value: 'Somewhat Unstable' },
      { value: 'Very Unstable' },
    ],
  },
  {
    propertyName: 'stress',
    label: 'stress',
    type: 'select',
    options: [
      { value: 'No stress' },
      { value: 'Low' },
      { value: 'Average' },
      { value: 'High' },
    ],
  },
  {
    propertyName: 'birth_control_pill',
    label: 'birth control pill',
    type: 'select',
    options: [
      { value: 'Taken' },
      { value: 'Late' },
      { value: 'Missed' },
      { value: 'Double' },
    ],
  },
  {
    propertyName: 'injection',
    label: 'injection',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Administered' },
      { value: 'Missed' },
    ],
  },
  {
    propertyName: 'ailment',
    label: 'ailment',
    type: 'select',
    options: [
      { value: 'None' },
      { value: 'Fever' },
      { value: 'COVID' },
      { value: 'Cold/Flu' },
      { value: 'Allergy' },
      { value: 'Injury' },
    ],
  },
  {
    propertyName: 'drinking',
    label: 'drinking',
    type: 'select',
    options: [
      { value: '0 drinks' },
      { value: '1 drink' },
      { value: '2 drinks' },
      { value: '3 drinks' },
      { value: '4+ drinks' },
    ],
  },
  {
    propertyName: 'cannabis',
    label: 'cannabis',
    type: 'select',
    options: [
      { value: 'No' },
      { value: 'Edible' },
      { value: 'Smoke' },
      { value: 'Vape' },
    ],
  },
  {
    propertyName: 'hangover',
    label: 'hangover',
    type: 'boolean',
  },
];
